import React from "react";
import { Route, Routes } from "react-router-dom";
import IncomeList from "../pages/IncomeRebate/IncomeList";
import RebateStatement from "../pages/jobs/RebateStatement";

export default function IncomeRebate() {
  return (
    <Routes>
      <Route path="" element={<IncomeList />} />
      <Route path="/statement" element={<RebateStatement />} />
    </Routes>
  );
}
